/* Cho-Yeh Trunk Club landing page: hero gallery + order flow. */
(function(){
  var track = document.getElementById("tc-gal-track");
  if (!track) return;
  var imgs  = track.querySelectorAll(".gal-img");
  var dots  = document.getElementById("tc-gal-dots");
  var prev  = document.getElementById("tc-gal-prev");
  var next  = document.getElementById("tc-gal-next");
  var i = 0;

  for (var n = 0; n < imgs.length; n++){
    var d = document.createElement("button");
    d.type = "button"; d.className = "gal-dot";
    d.setAttribute("aria-label", "Photo " + (n+1) + " of " + imgs.length);
    d.setAttribute("data-i", n);
    dots.appendChild(d);
  }
  var dotEls = dots.querySelectorAll(".gal-dot");

  function go(n){
    n = Math.max(0, Math.min(imgs.length - 1, n));
    track.scrollTo({ left: n * track.clientWidth, behavior: "smooth" });
  }
  function sync(){
    var w = track.clientWidth || 1;
    var n = Math.round(track.scrollLeft / w);
    if (n === i) return;
    i = n;
    for (var k = 0; k < dotEls.length; k++){
      dotEls[k].setAttribute("aria-current", k === i ? "true" : "false");
    }
    prev.disabled = i === 0;
    next.disabled = i === imgs.length - 1;
  }

  dotEls[0].setAttribute("aria-current", "true");
  prev.disabled = true;

  prev.onclick = function(){ go(i - 1); };
  next.onclick = function(){ go(i + 1); };
  for (var k = 0; k < dotEls.length; k++){
    dotEls[k].onclick = function(){ go(+this.getAttribute("data-i")); };
  }
  track.addEventListener("scroll", function(){
    clearTimeout(track._t);
    track._t = setTimeout(sync, 60);
  }, { passive:true });
  track.addEventListener("keydown", function(e){
    if (e.key === "ArrowRight"){ e.preventDefault(); go(i + 1); }
    if (e.key === "ArrowLeft"){ e.preventDefault(); go(i - 1); }
  });
  window.addEventListener("resize", function(){ go(i); });
})();

(function(){
  "use strict";

  var SIZES = [
    {v:"Youth XS", t:"XS", g:"YOUTH"},{v:"Youth Small", t:"S", g:"YOUTH"},
    {v:"Youth Medium", t:"M", g:"YOUTH"},{v:"Youth Large", t:"L", g:"YOUTH"},
    {v:"Adult Small", t:"S", g:"ADULT"},{v:"Adult Medium", t:"M", g:"ADULT"},
    {v:"Adult Large", t:"L", g:"ADULT"},{v:"Adult XL", t:"XL", g:"ADULT"},
    {v:"Adult 2XL", t:"2XL", g:"ADULT"},{v:"Adult 3XL", t:"3XL", g:"ADULT"}
  ];
  var QUARTERLY = 59.99, ANNUAL = 219.96, ANNUAL_PER = 54.99;
  var SHIP = 5;   /* flat rate per trunk delivery; during the pre-order Trunk 001 ships free (automatic discount) */
  var PROMO = window.__TC_PROMO === true;
  var D = window.__TC_DATA || {};
  var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var STEPS = 3;

  var uid = 0;
  var S = { step:1, campers:[mk()], plan:"quarterly", err:"" };

  function mk(){ return {id:++uid, name:"", size:"Youth Medium"}; }

  var $ = function(id){ return document.getElementById(id); };
  var sheet=$("tc-sheet"), body=$("tc-body"), nextBtn=$("tc-next"),
      backBtn=$("tc-back"), barFill=$("tc-bar"), stepNo=$("tc-stepno");
  if (!sheet || !body) return;

  function money(n){ return "$" + n.toFixed(2).replace(/\.00$/,""); }
  function perCamper(){ return S.plan === "annual" ? ANNUAL : QUARTERLY; }
  /* Promo: the first trunk is free. Quarterly -> the whole first charge.
     Annual -> one trunk off the year, so $54.99 not $59.99. */
  function creditEach(){ return PROMO ? (S.plan === "annual" ? ANNUAL_PER : QUARTERLY) : 0; }
  function subtotal(){ return S.campers.length * perCamper(); }
  function credit(){ return S.campers.length * creditEach(); }
  function dueToday(){ return subtotal() - credit(); }
  function shipToday(){ return PROMO ? 0 : (S.plan === "annual" ? SHIP * 4 : SHIP); }
  function totalToday(){ return dueToday() + shipToday(); }
  function esc(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c];
    });
  }
  function sizeGrid(id, sel, kind, mini){
    var h = '<div class="sizes">';
    SIZES.forEach(function(s){
      h += '<button type="button" class="sz'+(mini?' mini':'')+'" data-'+kind+'="'+id+'|'+s.v+'" aria-pressed="'
         + (sel === s.v) + '"><b>'+s.g+'</b>'+s.t+'</button>';
    });
    return h + '</div>';
  }

  function render(){
    barFill.style.width = ((S.step / STEPS) * 100) + "%";
    stepNo.textContent = "STEP " + S.step + " OF " + STEPS;
    backBtn.hidden = S.step === 1;
    nextBtn.textContent = S.step === STEPS ? "Continue to checkout" : "Continue";
    body.innerHTML = [step1, step2, step3][S.step - 1]();
    wire();
    body.parentElement.scrollTop = 0;
    if (S.step === 1){
      var f = body.querySelector("input[data-name]");
      if (f) { try{ f.focus({preventScroll:true}); }catch(e){} }
    }
  }

  function step1(){
    var h = '<h2 id="tc-step-title">Who is this for?</h2>'
          + '<p class="sub">This is the name we\'ll put on the trunk. Adding more than one camper? Each gets their own box, in their own size.</p>';
    S.campers.forEach(function(c, i){
      h += '<div class="camper"><div class="camper-h"><span class="badge">CAMPER ' + (i+1) + '</span>'
         + (S.campers.length > 1 ? '<button class="rm" data-rm="'+c.id+'">Remove</button>' : '')
         + '</div><div class="fld"><label for="tc-nm'+c.id+'">CAMPER\'S FIRST NAME</label>'
         + '<input id="tc-nm'+c.id+'" data-name="'+c.id+'" type="text" value="'+esc(c.name)+'" placeholder="Emma" autocomplete="off"></div>'
         + '<div class="fld"><label>SHIRT SIZE</label>' + sizeGrid(c.id, c.size, "size") + '</div></div>';
    });
    h += '<button class="addmore" id="tc-addc">+ Add another camper</button>';
    if (S.err) h += '<p class="err">' + esc(S.err) + '</p>';
    return h;
  }

  function step2(){
    var n = S.campers.length, plural = n > 1 ? (n + " campers") : "1 camper";
    return '<h2 id="tc-step-title">Pick your plan</h2>'
      + '<p class="sub">Four trunks a year either way. You\'re signing up ' + plural + '.</p>'
      + '<div class="planpick">'
      +   '<button type="button" class="po" data-plan="quarterly" aria-pressed="'+(S.plan==="quarterly")+'">'
      +     '<span class="flag2">' + (PROMO ? "FIRST TRUNK FREE" : "MOST POPULAR") + '</span><span class="dot"></span>'
      +     '<span class="po-main"><span class="t">Quarterly &middot; pay as you go</span>'
      +       '<span class="d">Billed every 90 days, plus $5 shipping. Skip or cancel any time after your ' + (PROMO ? 'first paid trunk' : 'second trunk') + '.</span>'
      +       (PROMO ? '<span class="pbadge">Nothing today &mdash; billing starts with Trunk 002</span>' : '')
      +     '</span>'
      +     '<span class="p">'
      +       (PROMO ? '<s class="was">' + money(QUARTERLY * n) + '</s>' + money(0) + '<small>due today</small>'
                     : money(QUARTERLY * n) + '<small>every 90 days</small>')
      +     '</span>'
      +   '</button>'
      +   '<button type="button" class="po" data-plan="annual" aria-pressed="'+(S.plan==="annual")+'">'
      +     '<span class="flag2 alt">' + (PROMO ? "FIRST TRUNK FREE" : "BEST VALUE") + '</span><span class="dot"></span>'
      +     '<span class="po-main"><span class="t">Annual &middot; prepay the year</span>'
      +       '<span class="d">All four trunks in one payment' + (PROMO ? ', shipping included' : ', plus $5 shipping each') + '. Locks your rate for the year.</span>'
      +       (PROMO ? '<span class="savex">Four trunks &mdash; pay for three</span>'
                     : '<span class="savex">' + money(ANNUAL_PER) + ' a trunk &mdash; save ' + money(20 * n) + '</span>')
      +     '</span>'
      +     '<span class="p"><s class="was">' + money((PROMO ? ANNUAL : QUARTERLY * 4) * n) + '</s>'
      +       money((PROMO ? ANNUAL - ANNUAL_PER : ANNUAL) * n)
      +       '<small>' + (PROMO ? "due today" : "for the year") + '</small></span>'
      +   '</button>'
      + '</div>';
  }

  function step3(){
    var n = S.campers.length;
    var h = '<h2 id="tc-step-title">Your order</h2>'
      + '<p class="sub">One subscription per camper, all on a single payment.</p><div class="lines">';
    S.campers.forEach(function(c){
      h += '<div class="line"><div><div class="nm">Trunk Club &mdash; ' + esc(c.name || "Camper") + '</div>'
         + '<div class="mt">' + esc(c.size) + ' &middot; '
         + (S.plan === "annual" ? "Annual, 4 trunks" : "Quarterly, billed every 90 days")
         + '</div></div><div class="amt">' + money(perCamper()) + '</div></div>';
    });
    if (PROMO){
      h += '<div class="line credit"><div><div class="nm">Pre-order offer &mdash; first trunk free</div>'
         + '<div class="mt">' + (S.plan === "annual" ? "One trunk off your first year" : "Trunk 001, on us")
         + ' &middot; ends October 14</div></div>'
         + '<div class="amt">&minus;' + money(credit()) + '</div></div>';
    }
    h += '<div class="line' + (PROMO ? ' credit' : '') + '"><div><div class="nm">Shipping</div><div class="mt">'
       + (PROMO ? (S.plan === "annual" ? "Covered all first year" : "Trunk 001 ships free")
                : (S.plan === "annual" ? "$5 &times; 4 trunks" : "Flat rate"))
       + '</div></div><div class="amt">' + (PROMO ? "FREE" : money(shipToday())) + '</div></div>';
    h += '<div class="tot"><span class="l">TOTAL TODAY</span><span class="v">' + money(totalToday()) + '</span></div></div>';
    h += '<p class="renew"><strong>Trunks begin shipping November 1'
      + (PROMO && S.plan !== "annual" ? ' &mdash; free' : '') + '.</strong><br>'
      + (PROMO
          ? (S.plan === "annual"
              ? "You're paying for three trunks and getting four, and your first year ships free. Renews at " + money(ANNUAL * n) + " plus shipping in 12 months."
              : "Your card is saved today but not charged. The first " + money(QUARTERLY * n)
                + " plus $5 shipping comes about 90 days from now, with Trunk 002, then every 90 days after.")
          : (S.plan === "annual"
              ? "Renews at " + money(ANNUAL * n) + " plus shipping in 12 months."
              : "Then " + money(QUARTERLY * n) + " plus $5 shipping every 90 days."))
      + ' '
      + (S.plan === "annual"
          ? "Manage it any time from your account."
          : "After your " + (PROMO ? "first paid trunk" : "second trunk") + ", skip or cancel any time from your account.")
      + '</p>';
    return h;
  }

  function wire(){
    var add = $("tc-addc");
    if (add) add.onclick = function(){ S.campers.push(mk()); S.err=""; render(); };
    body.querySelectorAll("[data-rm]").forEach(function(b){
      b.onclick = function(){
        var id = +b.getAttribute("data-rm");
        S.campers = S.campers.filter(function(c){ return c.id !== id; });
        render();
      };
    });
    body.querySelectorAll("[data-name]").forEach(function(inp){
      inp.oninput = function(){
        var id = +inp.getAttribute("data-name");
        S.campers.forEach(function(c){ if (c.id === id) c.name = inp.value; });
      };
    });
    body.querySelectorAll("[data-size]").forEach(function(b){
      b.onclick = function(){
        var p = b.getAttribute("data-size").split("|"), id = +p[0];
        S.campers.forEach(function(c){ if (c.id === id) c.size = p[1]; });
        render();
      };
    });
    body.querySelectorAll("[data-plan]").forEach(function(b){
      b.onclick = function(){ S.plan = b.getAttribute("data-plan"); render(); };
    });
  }

  /* ---------- hand the order to Shopify ----------
     One line per camper: the size picks the variant, the plan picks the Seal selling plan,
     and the camper's name rides along as a line item property. Existing Trunk Club lines
     are cleared first so a second visit can't stack duplicate subscriptions; anything else
     already in the cart is left alone. During the pre-order window the matching code is
     applied on the way into checkout. */
  function fail(msg){
    nextBtn.disabled = false; backBtn.disabled = false;
    nextBtn.textContent = "Continue to checkout";
    var old = body.querySelector(".err.handoff"); if (old) old.remove();
    var p = document.createElement("p"); p.className = "err handoff"; p.textContent = msg;
    body.appendChild(p);
  }
  function post(url, data){
    return fetch(R + url, { method:"POST", credentials:"same-origin",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" }, body: JSON.stringify(data) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); });
  }
  function checkout(){
    var plan = S.plan === "annual" ? D.annual : D.quarterly;
    var items = [], missing = [];
    S.campers.forEach(function(c){
      var vid = D.variants && D.variants[c.size];
      if (!vid) { missing.push(c.size); return; }
      items.push({ id: vid, quantity: 1, selling_plan: plan, properties: { "Camper": c.name.trim() } });
    });
    if (!plan || !items.length || missing.length){
      fail("We couldn't start your order just now. Please try again in a minute, or email tradingpost@cho-yeh.org.");
      return;
    }
    nextBtn.disabled = true; backBtn.disabled = true;
    nextBtn.textContent = "Heading to checkout…";
    var code = PROMO ? (S.plan === "annual" ? D.codeAnnual : D.codeQuarterly) : "";
    fetch(R + "cart.js", { credentials:"same-origin", headers:{ "Accept":"application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var updates = {}, n = 0;
        (cart.items || []).forEach(function(it){ if (it.product_id === D.productId){ updates[it.key] = 0; n++; } });
        return n ? post("cart/update.js", { updates: updates }) : null;
      })
      .then(function(){ return post("cart/add.js", { items: items }); })
      .then(function(){
        var dest = R + "checkout";
        window.location.href = code
          ? R + "discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent(dest)
          : dest;
      })
      .catch(function(err){
        var why = (err && (err.description || err.message)) || "";
        fail("Something went wrong adding your trunk" + (why ? " (" + why + ")" : "") + ". Please try again.");
      });
  }

  nextBtn.onclick = function(){
    if (S.step === 1){
      if (S.campers.some(function(c){ return !c.name.trim(); })){
        S.err = "Add a name for each camper so we know whose trunk is whose.";
        render(); return;
      }
      S.err = "";
    }
    if (S.step === STEPS){ checkout(); return; }
    S.step++; render();
  };

  backBtn.onclick = function(){ if (S.step > 1){ S.step--; render(); } };

  function open(){ sheet.hidden = false; document.body.style.overflow = "hidden"; render(); }
  function close(){ sheet.hidden = true; document.body.style.overflow = ""; }
  ["tc-open1","tc-open2","tc-open3"].forEach(function(id){ var el=$(id); if (el) el.onclick = open; });
  $("tc-close").onclick = close;
  sheet.addEventListener("click", function(e){ if (e.target === sheet) close(); });
  document.addEventListener("keydown", function(e){ if (e.key === "Escape" && !sheet.hidden) close(); });
})();